import { render, staticRenderFns } from "./ShowImportPlaceholder.vue?vue&type=template&id=03e340df&"
import script from "./ShowImportPlaceholder.vue?vue&type=script&lang=js&"
export * from "./ShowImportPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports